module.exports = __webpack_public_path__ + "static/media/logo-padilla-quienes.d1008268.svg";